import { FetchLeadSuccessResponse } from 'modules/leads/types';
import { convertSnakeToCamelCase } from 'utils/convertSnakeToCamelCase';

export const translateFetchLead = (response: object) => {
  const convertedResponse: FetchLeadSuccessResponse =
    convertSnakeToCamelCase(response);
  return convertedResponse;
};
